import { render, staticRenderFns } from "./s-imgZoom.vue?vue&type=template&id=000efbfe&scoped=true"
import script from "./s-imgZoom.vue?vue&type=script&lang=js"
export * from "./s-imgZoom.vue?vue&type=script&lang=js"
import style0 from "./s-imgZoom.vue?vue&type=style&index=0&id=000efbfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000efbfe",
  null
  
)

export default component.exports